import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';

export interface ContextMenuModel{
  menuText: string;
  menuEvent: string;
}

@Component({
  selector: 'app-custom-right-click',
  templateUrl: './custom-right-click.component.html',
  styleUrls: ['./custom-right-click.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomRightClickComponent implements OnInit {
  @Input()
  contextMenuItems: Array<ContextMenuModel>;

  @Output()
  onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }
  
  onContextMenuClick(event, data): any {
    this.onContextMenuItemClick.emit({
      event,
      data,
    });
  }

}
